

<kendo-grid class="isg-grid"
            [data]="gridService | async"
            [loading]="gridService.loading"
            [pageSize]="state.take"
            [skip]="state.skip"
            [sort]="state.sort"
            [navigable]="true"
            [pageable]="{
                  pageSizes:[5, 10, 15, 20, 50]
            }"
            (dataStateChange)="onStateChange($event)"
            (edit)="editHandler($event)"
            [height]="heightGrid">

  <kendo-grid-column field="assigned" title="Assigned" editor="boolean" [width]="80" class="isg-kgrid-cell-center">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [appNullableBooleanClass]="dataItem.assigned"></span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="active" title="Is Active" editor="boolean" [width]="80" class="isg-kgrid-cell-center">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span [appNullableBooleanClass]="dataItem.active"></span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="firstName" title="First Name"> </kendo-grid-column>
  <kendo-grid-column field="lastName" title="Last Name"> </kendo-grid-column>
  <kendo-grid-column field="email" title="Email"> </kendo-grid-column>
  <kendo-grid-column field="moduleId" title="Module(s)" [width]="200">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="isg-kgrid-cell-vertscroll-m">
        {{ dataItem.userModules }}
      </div>
    </ng-template>
  </kendo-grid-column>


  <kendo-grid-column title="Send Access Email" editor="boolean" field="checked" [width]="150" class="isg-kgrid-cell-center">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span *ngIf="dataItem.assigned === true && (dataItem.lastLogin === null || dataItem.lastLogin === undefined)" [(appNullableBooleanClass)]="dataItem.checked" [allowClickToggle]="true" [allowTrueFalseToggle]="true"></span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="lastLogin" title="Last Login" editor="date" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.lastLogin | datePreference:true}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="accessSent" title="Access Sent On" editor="date" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.accessSent | datePreference:true}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="" [width]="50">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
      <button kendoGridEditCommand
              title="Edit User"
              [primary]="true">
        <span class="fas fa-pencil"></span>
      </button>
    </ng-template>
  </kendo-grid-command-column>

  <kendo-grid-messages [pagerItemsPerPage]="'Users per request'" [pagerItems]="'Users'"
                       [pagerOf]="'of'" [pagerPage]="'Page'">
  </kendo-grid-messages>

</kendo-grid>

